import { FC } from "react";
import moment from "moment/moment";
import { TooltipProps } from "@mui/material";
import {
  dateFromUtcByTimeZone,
  formatDate,
} from "../../../../../../../utils/helpers/date-time/datetime-format";
import { TooltipText } from "../../../../../../common/TooltipText";

interface DateTimeCellRendererProps {
  data: string;
  title?: TooltipProps["title"];
}

export const DateTimeCellRenderer: FC<DateTimeCellRendererProps> = ({
  data,
  title,
}) => {
  if (!data) {
    return null;
  }
  const formattedData = moment(dateFromUtcByTimeZone(data));

  const value = moment(formattedData).fromNow();

  const titleDate = `${formatDate(formattedData, {
    type: "dateTime",
  })}`;

  return (
    <TooltipText tooltipTitle={title || titleDate} variant="body2">
      {value}
    </TooltipText>
  );
};
